export default function (nga, admin, Api) {
    let entity = admin.getEntity('event')
        .updateMethod('patch')
        .label('EVENTS')
    //.readOnly();

    entity.listView()
        .fields([
            nga.field('id').detailLinkRoute('show').isDetailLink(true),
            nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(true),
            nga.field('location').label('LOCATION').detailLinkRoute('show').isDetailLink(true),
            nga.field('date', 'date').label('DATE').label('DATE').format('yyyy-MM-dd / HH:mm'),
            nga.field('interested')
                .label('INTERESTED')
                .template('<ma-filtered-list-button label="{{ value }}" entity-name="interested" ' +
                    'filter="{  event: entry.values.id }" size="xs"></ma-filtered-list-button>')
        ])
        .sortDir('asc')
        .url('events')
        .prepare(['Restangular', 'datastore', 'entries', 'Entry', function(Restangular, datastore, entries, Entry){
            return Restangular
                .all('interesteds')
                .getList({_sortDir: "ASC", _sortField: "created"})
                .then(data => {
                    data = data.data ? data.data : data;

                    entries.forEach(function(e, i){
                        e.values.interested = 0;

                        data.forEach(function(i, ii){
                            if(i.event && i.event.id == e.values.id)
                                e.values.interested++;
                        });
                    })
                });
            }]
        );

    entity.showView().fields([
        nga.field('name').label('NAME'),
        nga.field('description').label('DESCRIPTION'),
        nga.field('date', 'date').label('DATE').format('yyyy-MM-dd / HH:mm'),
        nga.field('image').label('IMAGE')
            .template('<img src="/uploads/events/{{ entry.values[\'image\'] }}" style="max-width: 100%;"/>'),
        nga.field('location').label('LOCATION'),
        nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),
        nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd'),
        nga.field('email').label('EMAIL'),
        nga.field('interested', 'referenced_list')
            .label('INTERESTED')
            .targetEntity(nga.entity('interested').url('interesteds'))
            .targetReferenceField('event')
            .targetFields([
                nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(false),
                nga.field('surname').label('SURNAME').detailLinkRoute('show').isDetailLink(false),
                nga.field('email').label('EMAIL').detailLinkRoute('show').isDetailLink(false),
                nga.field('phone').label('PHONE').detailLinkRoute('show').isDetailLink(false)
            ]),
        nga.field('').label('')
            .template('<ma-filtered-list-button label="See all related interested" entity-name="interested" ' +
            'filter="{  event: entry.values.id }" size="sm" class="pull-right"></ma-filtered-list-button>')

    ]);

    entity.creationView().fields([
        nga.field('name').label('NAME'),
        nga.field('description', 'text').label('DESCRIPTION'),
        nga.field('date', 'datetime').format('yyyy-MM-dd HH:mm').label('DATE').map(ParseDate),
        nga.field('image', 'file').label('IMAGE')
            .uploadInformation({ 'url': Api.Path+'event/upload', 'apifilename': 'file'}),
        nga.field('location').label('LOCATION'),
        nga.field('email').label('EMAIL'),
        nga.field('created', 'date').label('CRETED').format('yyyy-MM-dd').map(ParseDate),
        nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd').map(ParseDate),
        nga.field('location_map').label('LOCATION_MAP')

    ]);

    entity.editionView().fields(entity.creationView().fields());
    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/event/config.js
 **/